import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { stringIsNullOrEmpty } from "../../util/Util";
import SurveyModal from "./SurveyModal";

const SURVEY_MONSTER_URL = "https://cdn.i8global.com/i8app/survey/survey_monster.png";

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function formatSurveyDate(value) {
    if (stringIsNullOrEmpty(value)) {
        return "";
    }
    const parsed = new Date(String(value).replace(" ", "T"));
    if (Number.isNaN(parsed.getTime())) {
        return String(value);
    }
    return String(parsed.getDate()).padStart(2, "0") + " " + months[parsed.getMonth()] + " " + parsed.getFullYear();
}

const SurveyEventCard = ({ survey, platform, onSubmitted, onOpenChange }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const [modalKey, setModalKey] = useState(0);
    const campaign = survey && survey.campaign;
    const campaignId = campaign && campaign.id;
    const endDate = formatSurveyDate(campaign && campaign.endDate);

    useEffect(() => {
        setModalKey((key) => key + 1);
    }, [campaignId]);

    useEffect(() => {
        return () => {
            if (onOpenChange) {
                onOpenChange(false);
            }
        };
    }, [onOpenChange]);

    function setOpen(next) {
        setIsOpen(next);
        if (onOpenChange) {
            onOpenChange(next);
        }
    }

    if (!survey) {
        return null;
    }

    return (
        <>
            {!survey.submitted && (
                <article className="gw-card survey-event-card">
                    <div className="survey-event-card__banner">
                        <img src={SURVEY_MONSTER_URL} alt="" />
                    </div>
                    <div className="gw-card-body">
                        <div className="gw-status-row">
                            <div className="gw-tags">
                                <span className="gw-status is-ongoing">
                                    <span className="gw-dot" />
                                    {t("GIVEAWAY_ONGOING")}
                                </span>
                                <span className="gw-type">{t("EVENT_TYPE_SURVEY")}</span>
                            </div>
                        </div>
                        <h3 className="gw-title">{campaign && campaign.title ? campaign.title : t("SURVEY_FEEDBACK_BUTTON")}</h3>
                        <p className="survey-event-card__desc">{t("SURVEY_INTRO_HERO_BODY")}</p>
                        {!stringIsNullOrEmpty(endDate) && (
                            <div className="gw-dates">
                                <div>
                                    <div className="gw-date-label">{t("END_DATE")}</div>
                                    <div className="gw-date-value">{endDate}</div>
                                </div>
                            </div>
                        )}
                        <div className="gw-actions">
                            <button type="button" className="gw-join" onClick={() => setOpen(true)}>
                                {t("SURVEY_START")}
                            </button>
                        </div>
                    </div>
                </article>
            )}
            <SurveyModal
                key={modalKey}
                isOpen={isOpen}
                survey={survey}
                platform={platform}
                onClose={() => setOpen(false)}
                onSubmitted={onSubmitted}
            />
        </>
    );
};

export default SurveyEventCard;
